import { makeVar } from "@apollo/client";

export const isFocusSearchInputVar = makeVar<boolean>(false);

/**
 *
 */
export type TypeFocus = "search" | "filter" | "default";

/**
 *
 */
export interface ISelectFocus {
  type: TypeFocus;
  isShow: boolean;
}

export const defaultSelectFocus: ISelectFocus = {
  type: "default",
  isShow: false,
};

export const focusSelectedVar = makeVar<ISelectFocus>(defaultSelectFocus);

export const searchTextVar = makeVar<string>("");
